import { BORNES_PAPIER } from './bornes.js';
/**
 * Les bornes d'un papier posé sur la carte, appliquées (chantier post-it-et-listes, tickets 01
 * et 03). Écrites une fois ici : le serveur les applique à ce qu'il reçoit
 * (`server/src/domain/papiers/regles.ts`), l'écran à la poignée qu'on tire et au papier qu'on
 * glisse, pour qu'il ne passe jamais par une taille que le serveur ramènerait au lâcher.
 *
 * Hors bornes, une mesure est **ramenée aux bornes**, jamais refusée : une poignée tirée trop
 * loin, un papier glissé au bord, le geste aboutit au plus près de ce qu'on voulait.
 */
/** Une valeur au pixel entier, entre `min` et `max`. */
export function bornerMesureDePapier(valeur, min, max) {
    return Math.min(max, Math.max(min, Math.round(valeur)));
}
/** La taille d'un papier, en pixels entiers, entre le minimum et le maximum. */
export function bornerTailleDePapier(taille) {
    return {
        largeur: bornerMesureDePapier(taille.largeur, BORNES_PAPIER.largeurMin, BORNES_PAPIER.largeurMax),
        hauteur: bornerMesureDePapier(taille.hauteur, BORNES_PAPIER.hauteurMin, BORNES_PAPIER.hauteurMax),
    };
}
/** La place d'un papier (son centre, relatif au centre de la carte), en pixels entiers, sur la carte. */
export function bornerPlaceDePapier(place) {
    return {
        x: bornerMesureDePapier(place.x, -BORNES_PAPIER.placeMax, BORNES_PAPIER.placeMax),
        y: bornerMesureDePapier(place.y, -BORNES_PAPIER.placeMax, BORNES_PAPIER.placeMax),
    };
}
